// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.title-text{
    font-weight: 700;
}
.description-text{
    color: #ccc;
}
.link{
    cursor: pointer;
    outline: none;
}
/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNldHVwLmNvbXBvbmVudC5jc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7SUFDSSxnQkFBZ0I7QUFDcEI7QUFDQTtJQUNJLFdBQVc7QUFDZjtBQUNBO0lBQ0ksZUFBZTtJQUNmLGFBQWE7QUFDakIiLCJmaWxlIjoic2V0dXAuY29tcG9uZW50LmNzcyIsInNvdXJjZXNDb250ZW50IjpbIi50aXRsZS10ZXh0e1xuICAgIGZvbnQtd2VpZ2h0OiA3MDA7XG59XG4uZGVzY3JpcHRpb24tdGV4dHtcbiAgICBjb2xvcjogI2NjYztcbn1cbi5saW5re1xuICAgIGN1cnNvcjogcG9pbnRlcjtcbiAgICBvdXRsaW5lOiBub25lO1xufSJdfQ== */`, "",{"version":3,"sources":["webpack://./src/app/secure/setup/setup.component.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;AACpB;AACA;IACI,WAAW;AACf;AACA;IACI,eAAe;IACf,aAAa;AACjB;AACA,4eAA4e","sourcesContent":[".title-text{\n    font-weight: 700;\n}\n.description-text{\n    color: #ccc;\n}\n.link{\n    cursor: pointer;\n    outline: none;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
